export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/ee9e541a-c8ce-4ede-b1f2-17f9d68c23d6.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/bd6d0a0d-10ca-4bfe-92d3-5b62a6b8270e.png',
};
